

document.addEventListener("click", (e) => {
  const openTrigger = e.target.closest("[data-open-drawer]");

  if (openTrigger) {
    e.preventDefault();

    const name = openTrigger.dataset.openDrawer;

    document.dispatchEvent(new CustomEvent("drawer:before-open", { detail: { name } }));
    document.dispatchEvent(new CustomEvent(`${name}:open`));
    return;
  }

  const closeTrigger = e.target.closest("[data-close-drawer]");

  if (closeTrigger) {
    e.preventDefault();
    document.dispatchEvent(new CustomEvent(`${closeTrigger.dataset.closeDrawer}:close`));
  }
});
